import Component from '../Component';
import app from '../app';
/**
 * A generic component for displaying a label and value inline.
 * Created to avoid reinventing the wheel.
 *
 * `label: value`
 */
export default class LabelValue extends Component {
  view(vnode) {
    return m("div", {
      className: "LabelValue"
    }, m("div", {
      className: "LabelValue-label"
    }, app.translator.trans('core.lib.data_segment.label', {
      label: this.attrs.label
    })), m("div", {
      className: "LabelValue-value"
    }, this.attrs.value));
  }
}
flarum.reg.add('core', 'common/components/LabelValue', LabelValue);